// extracted by mini-css-extract-plugin
export var modal = "_bk-0";